
import { Vue, Component } from 'vue-property-decorator'
import User from '@/types/user'
import ls from '@/ls'
import UserShowDetailsTab from '@/views/user/tabs/show/UserShowDetailsTab.vue'
import UserShowRolesPermissionsTab from '@/views/user/tabs/show/UserShowRolesPermissionsTab.vue'
import ActivityLogTable from '@/components/ActivityLogTable.vue'
import { can } from '@/globalFunctions'

@Component({
  methods: { can },
  components: { ActivityLogTable, UserShowRolesPermissionsTab, UserShowDetailsTab }
})

export default class UserShow extends Vue {
  settings = {
    routeNames: { list: 'users', show: 'userShow', edit: 'userEdit' },
    routeParamKey: 'userId',
    functionNames: { setCurrent: 'setCurrentUser', clearCurrent: 'clearCurrentUser', save: 'saveUser' },
    getterNames: { current: 'currentUser', loading: 'loadingUser' }
  }

  currentTab:string = ls.get('userShowActiveTab') || 'details'

  mounted () : void {
    this.$store.dispatch(this.settings.functionNames.setCurrent, this.$route.params[this.settings.routeParamKey])
  }

  destroyed () : void {
    this.$store.dispatch(this.settings.functionNames.clearCurrent)
  }

  setActiveTab (tab:string) : void {
    ls.set('userShowActiveTab', tab)
    this.currentTab = tab
  }

  navigateTo (routeName:string, id:number|undefined) : void {
    if (id) {
      this.$router.push({ name: routeName, params: { [this.settings.routeParamKey]: id.toString() } })
    } else {
      this.$router.push({ name: routeName })
    }
  }

  previousPage () : void {
    this.$router.go(-1)
  }

  get currentItem () : User {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get loading () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].item
  }

  get saving () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].save
  }
}
